import { TrailMaker } from "./TrailMaker";
export async function loadExternalTrailInteraction(engine, refresh = true) {
    await engine.addInteractor("externalTrail", (container) => new TrailMaker(container), refresh);
}
export * from "./Options/Classes/Trail";
export * from "./Options/Interfaces/ITrail";
